// extracted by mini-css-extract-plugin
export default {"centerControlsWrapper":"styles_centerControlsWrapper__YmBy9","centerControls":"styles_centerControls__-OI7m","control":"styles_control__2rTVO"};